import React, { useEffect, useState } from 'react';

import { ReactComponent as ConnectorIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import TabToggle from '../../shared-components/tab-toggle/TabToggle';

import Global from './components/Global';
import Local from './components/Local';

/**
 * Component for displaying connector management with Local and Global tabs
 * @returns {React.JSX.Element} Connector management component
 */
function ConnectorManagement() {
  const dispatch = useAppDispatch();
  const { totalResults: localTotal } = useAppSelector((state) => state.connector);
  const { totalResults: globalTotal } = useAppSelector((state) => state.globalConnector);
  const [selectedTab, setSelectedTab] = useState<string>('Local');

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: 'Connector Rating',
        count: selectedTab === 'Local' ? localTotal : globalTotal,
        icon: <ConnectorIcon />,
      }),
    );
  }, [dispatch, localTotal, globalTotal, selectedTab]);

  return (
    <div className="connector-management-wrap">
      <div className="connector-management-container">
        <div className="table-content">
          <div className="tab-toggle-wrapper">
            <TabToggle
              tabs={[
                { label: 'Local', value: 'Local' },
                { label: 'Global', value: 'Global' },
              ]}
              defaultTab="Local"
              onChange={(tab) => setSelectedTab(tab)}
            />
          </div>

          {selectedTab === 'Local' ? <Local /> : <Global />}
        </div>
      </div>
    </div>
  );
}

export default ConnectorManagement;
